import React from 'react';
import { List } from 'semantic-ui-react'
import {flowRight as compose} from 'lodash';
import {graphql} from 'react-apollo';
import queries from '../../../utils/queries'

import TitDer from '../../../components/funcionales/titder';

const Detalle = ({elemento, handleClickidLista}) => {
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrLubricante}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrFabricante}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tipoLub}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.claseLub}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.categoriaLub}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tipoGrado}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrGrado}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.apiSAE}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.isoGrasa}</td>
      {/* <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrAplicacion}</td> */}
    </tr>
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <Detalle elemento={elemento}
        handleClickidLista={handleClickidLista}
        key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};



// const ConfLubricante2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
class ConfLubricante2 extends React.Component {  
  state={argsBuscLub: {}, ingresa: 'S'}

  componentDidUpdate(prevProps){
    if(this.props.argsBuscLub!==this.state.argsBuscLub || this.state.ingresa==='S'){
      let argsBuscLub = ""
      let argsBuscar = "tipoLub: {$in: ['Aceite', 'Grasa', 'Otro']}"
      if(this.props.argsBuscLub.descrFabricante){
        argsBuscar += `, 'descrFabricante': /${this.props.argsBuscLub.descrFabricante}/i`
      }
      if(this.props.argsBuscLub.descrLubricante){
        argsBuscar += `, 'descrLubricante': /${this.props.argsBuscLub.descrLubricante}/i`
      }
      argsBuscLub = {tipoqry: `[{$match: {${argsBuscar}}}, {$sort: {descrLubricante: 1}}]`}
      this.setState({ingresa: 'N'})
      console.log(argsBuscLub)
      this.props.allLubricante.refetch(argsBuscLub)  
      this.setState({argsBuscLub: this.props.argsBuscLub})    
    }
  }

  render(){
    let list = []
    const a052501 = this.props.autorizacUA.findIndex( autorizac => autorizac === "052501" );
    if(this.props.allLubricante.allLubricante){list = this.props.allLubricante.allLubricante}
console.log(list)
    return (
      <div>
        <List selection>
        <TitDer list={list} textBoton1="Lubricantes" btnNuevo={a052501!==-1?"SI":"NO"} styles={this.props.styles} handleClick={this.props.handleClick} />

        <div>
          <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Lubricante</th>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Marca</th>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Tipo Lub.</th>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Clase Lub.</th>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Categoría</th>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Tipo grado</th>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Grado</th>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>API</th>
                <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>ISO</th>
                </tr>
            </thead>
            <Lista list={list} handleClickidLista={this.props.handleClickidLista}/>
          </table>
          <p></p>
        </div>
        </List>
      </div>
    )
  }
};

export default compose(
  graphql(queries.query.allLubricante, {name:'allLubricante',
    options: (props) => {return {variables: {tipoqry: `[{$sort: {descrLubricante: 1}}]`}}}}),
    
) (ConfLubricante2)
